export default function TS_Arrays() {
  return (
    <div>
      <h1>TS Arrays</h1>
      <p>This is the TS Arrays page.</p>
    </div>
  );
}